module.exports = __webpack_public_path__ + "img/card_230620702.934f6b94.jpg";